import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('academic');

export class ProfessionalPracticeTerms extends Api {
  constructor(http, config = {}) {
    super(http, url, 'professional-practice', config);
  }
}